import axios from 'axios';
import {fetchConfig} from '../util/util';

const HOST_URL = fetchConfig('nableHostUrl');

const getAll = async () => {
  return (await axios.get(`${HOST_URL}/business-account`)).data;
};

export default {getAll};